export const LoadingScreen = () => {
  return (
    <div className="flex grow items-center justify-center">
      <i className="bi-arrow-clockwise animate-spin text-5xl" />
    </div>
  );
};
